export function floorMinute(d: Date) {
	if (d.getSeconds() === 0 && d.getMilliseconds() === 0) {
		return d;
	}
	return new Date(
		new Date(
			d.getFullYear(),
			d.getMonth(),
			d.getDate(),
			d.getHours(),
			d.getMinutes(),
			0,
			0
		)
	);
}

export function ceilMinute(d: Date) {
	if (d.getSeconds() === 0 && d.getMilliseconds() === 0) {
		return d;
	}
	return new Date(
		new Date(
			d.getFullYear(),
			d.getMonth(),
			d.getDate(),
			d.getHours(),
			d.getMinutes(),
			0,
			0
		).getTime() + 60000
	);
}

export function dateFromProto(val: number | Long): Date {
	if (!(typeof val === 'number')) {
		if (
			val.toNumber() === 0 ||
			val.compare(-8640000000000) === -1 ||
			val.compare(8640000000000) === 1
		) {
			throw new Error('Invalid date');
		}
		return new Date(val.toNumber() * 1000);
	}
	return new Date(val * 1000);
}
export function getDateHourZero(date:Date){
    return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0);
}

export function adjustForTimezone(date:Date):Date{
    var timeOffsetInMS:number = date.getTimezoneOffset() * 60000;
    
    return new Date(date.getTime() - timeOffsetInMS);
}
